import { CompanyLogo } from "../../../styles/component/style";
import { Images } from "../../../assets/images";
import {
  LogoContainer,
  LinksContainer,
  ProfileImage,
  ProfileName,
  LogoutText,
  BigScreen,
  SmallScreenMenu,
  SmallScreen,
  Row,
  Count,
  HelpIcon,
  LogoutIcon,
  CartIcon,
  H2,
  MobileScreen,
  IconHolder,
} from "./Styles";
import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import COLORS from "../../../assets/Colors";
import useUser from "../../../hooks/useUser";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import useCartCount from "../../../hooks/useCartCount";
import labels from "../../../helpers/labels.json";
import useAlert from "../../../hooks/useAlert";
import { Link, scroller } from "react-scroll";
import { TranslaterContext } from "../../../providers/TranslaterProvider";
import DropDownMenu from "../../common/DropDownMenu";
import TemporaryDrawer from "./Drawer";
import Notification from "../Notification";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsIcon from "@material-ui/icons/Notifications";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Button, Drawer } from "@material-ui/core";
import MenuModel from "./MenuModel";
import useFreshChat from "../../../hooks/useFreshChat";
import useSettings from "../../../hooks/useSettings";
import {
  PrimaryCTAButton,
  PrimaryOutlinedCTAButton,
} from "../../common/CustomButtons";

const EXCLUDE_URL = ["create-profile"];

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    minHeight: 70, // Changed from fixed height to min-height
    height: "auto", // Allow height to adjust
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid #e1e3ee",
    // Add responsive height adjustments
    [theme.breakpoints.up("md")]: {
      minHeight: 75,
    },
  },
  appSpacedBar: {
    zIndex: theme.zIndex.drawer + 1,
    background: COLORS.PRIMARY_WHITE,
    minHeight: 64, // Changed from fixed height
    height: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxShadow: "none",
    borderBottom: "1px solid #e1e3ee",
    marginTop: 40,
    [theme.breakpoints.up("md")]: {
      minHeight: 74,
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    minHeight: "64px !important", // Override default toolbar height
    padding: theme.spacing(0, 1), // Add responsive padding
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(0, 2),
    },
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(0, 3),
    },
    [theme.breakpoints.up("lg")]: {
      padding: theme.spacing(0, 4),
    },
  },
}));

export default function StyledAppBar({
  NavPages,
  hideLinks,
  LandingPage,
  ArbitPages,
  cartCount,
  setShowDrawer,
  stats,
  hideIcon,
  password,
}) {
  const classes = useStyles();
  const { userObject, setToken, token } = useUser();
  const { setCartCount, setContactScrollTick } = useCartCount();
  const { showAlert, hideAlert } = useAlert();
  const { translaterOpen } = useContext(TranslaterContext);
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const { authSetting } = useUser();
  const { setting, settingsLoading } = useSettings();
  const [notificationCount, setNotificationCount] = useState();
  const { setTag } = useFreshChat({ userObject }, true);
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const section = location.hash;

  useEffect(() => {
    if (!section) return;

    const redirectMap = {
      odr: "#odr",
      transcription: "#transcription",
      "case-management": "#case-management",
      "our-offerings": "#our-offerings",
      "enquire-now": "#enquire-now",
      home: "#home",
    };

    const matchedKey = Object.keys(redirectMap).find((key) =>
      section.includes(key),
    );

    if (matchedKey) {
      navigate(`${location.origin}/${redirectMap[matchedKey]}`);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [section]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        // scrolling down
        setShowHeader(false);
      } else {
        // scrolling up
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const handleLogout = () => {
    showAlert({
      heading: "Logout?",
      desc: "Are you sure you want to logout?",
      primaryBtnText: "Logout",
      secondaryBtnText: "Cancel",
      clickSecondarybtn: () => hideAlert(),
      clickPrimaryBtn: () => {
        setToken("logged_out");
        setTag(["home", "sign_up"]);
        setCartCount(0);
        hideAlert();
      },
      isOpen: true,
      onDialogClose: () => hideAlert(),
    });
  };

  return (
    // <AppBar
    //   position="fixed"
    //   style={{ boxShadow: "5px 5px 8px #00000011" }}
    //   className={translaterOpen ? classes.appSpacedBar : classes.appBar}
    // >

    <AppBar
      position="fixed"
      className={translaterOpen ? classes.appSpacedBar : classes.appBar}
      style={{
        boxShadow: "5px 5px 8px #00000011",
        transform: showHeader
          ? "translateY(0)"
          : token
            ? ""
            : "translateY(-100%)",
        transition: "transform 0.3s ease-in-out",
      }}
    >
      <Toolbar className={classes.toolbar}>
        {_.isEmpty(userObject) || !userObject?.emailVerified
          ? ""
          : !hideIcon && (
              <SmallScreen>
                <IconButton
                  edge="start"
                  color="black"
                  aria-label="menu"
                  onClick={() => setShowDrawer(true)}
                  size="small" // Make icon button responsive
                >
                  <MenuIcon style={{ color: `${COLORS.COLOR_DARK}` }} />
                </IconButton>
              </SmallScreen>
            )}

        {password === true ? (
          <LogoContainer>
            {settingsLoading ? null : (
              <CompanyLogo
                src={
                  authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
                }
              />
            )}
          </LogoContainer>
        ) : (
          // <LogoContainer>
          //   {settingsLoading ? null : (
          //     <CompanyLogo
          //       onClick={() =>
          //         LandingPage
          //           ? scroller.scrollTo("hero", {
          //               duration: 500,
          //               offset: -70,
          //               smooth: true,
          //             })
          //           : _.isEmpty(userObject) || !userObject?.emailVerified
          //           ? navigate("/")
          //           : navigate("/dashboard")
          //       }
          //       src={
          //         authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
          //       }
          //     />
          //   )}
          // </LogoContainer>

          <LogoContainer>
            {settingsLoading ? null : (
              <CompanyLogo
                onClick={() => {
                  if (window.location.pathname === "/") {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                    return;
                  }

                  LandingPage
                    ? scroller.scrollTo("hero", {
                        duration: 500,
                        offset: -70,
                        smooth: true,
                      })
                    : _.isEmpty(userObject) || !userObject?.emailVerified
                      ? navigate("/")
                      : navigate("/dashboard");
                }}
                src={
                  authSetting?.logoUrl || setting?.logoUrl || Images.companyLogo
                }
              />
            )}
          </LogoContainer>
        )}

        <BigScreen>
          {hideLinks ? null : (
            <LinksContainer>
              {_.isEmpty(userObject) ||
              !userObject?.emailVerified ||
              EXCLUDE_URL.some((path) => location?.pathname?.includes(path)) ? (
                <>
                  {/* {NavPages ? (
                    <> */}
                      {/* <H2>
                        <DropDownMenu
                          title={"Webinar"}
                          options={[
                            {
                              name: "Upcoming Webinars",
                              children: [
                                {
                                  name: `${setting?.title || "Webinars"}`,
                                  link: `/upcoming_webinars/${setting?.slug}`,
                                },
                              ],
                            },

                            {
                              name: "ODR-Opportunities & Challenges",
                              link: "/resources/webinar-videos#webinar#one",
                            },
                            {
                              name: "ODR-Evaluation of Section 11 & Section 29A",
                              link: "/resources/webinar-videos#webinar#two",
                            },
                            {
                              name: "Past Webinars",
                              link: "/past-webinars",
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={"Services"}
                          options={[
                            {
                              name: "Arbitrations & Mediations",
                              link: "#our-offerings",
                              section: "our-offerings",
                            },
                            {
                              name: "ODR Platform Deployments",
                              link: "#odr",
                              section: "our-offerings",
                            },
                            {
                              name: "Live Transcription",
                              link: "#transcription",
                              section: "our-offerings",
                            },
                            {
                              name: "Case Management",
                              link: "#case-management",
                              section: "our-offerings",
                            },
                            
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.resources"]}
                          options={[
                            {
                              name: "Blogs",
                              link: "/resources/blogs",
                            },
                            {
                              name: "Model Clauses",
                              link: "/resources/model-clauses",
                            },
                            {
                              name: "Rules",
                              children: [
                                {
                                  name: "Negotiation",
                                  link: `/negotiation-rules`,
                                },

                                {
                                  name: "Mediation",
                                  link: `/mediation-rules`,
                                },
                                {
                                  name: "Arbitration",
                                  link: `/arbitration-rules`,
                                },
                              ],
                            },
                            {
                              name: "Awards",
                              link: "/resources/awards",
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.neutral"]}
                          options={[
                            {
                              name: "Arbitrators",
                              link: "/neutral/arbitrators",
                            },
                            {
                              name: "Mediators",
                              link: "/neutral/mediators",
                            },
                            {
                              name: "Login as Neutral",
                              link: process.env.REACT_APP_NEUTRAL_BASE_URL,
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.training"]}
                          options={[
                            {
                              name: "Corporate Short Programme",
                              link: "/training/corporate-short-programme",
                            },
                            {
                              name: "Mediation Training Programme",
                              link: "/training/mediation-training-programme",
                            },
                            {
                              name: "World of Mediation",
                              link: "/training/world-of-mediation",
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.about_us"]}
                          options={[
                            {
                              name: "About IAMC",
                              link: "/about-us",
                              section: "about-justact",
                            },
                            {
                              name: "Our Advantages",
                              link: "/about-us#our-advantages",
                              section: "our-advantages",
                            },
                            {
                              name: "How IAMC works",
                              link: "/about-us#how-it-works",
                              section: "how-it-works",
                            },
                            {
                              name: "Our Values",
                              link: "/about-us#our-values",
                              section: "our-values",
                            },
                            {
                              name: "Board of Directors",
                              link: "/about-us#board-of-directors",
                              section: "board-of-directors",
                            },
                            {
                              name: "Management Team",
                              link: "/about-us#management-team",
                              section: "management-team",
                            },
                            {
                              name: "Our Partners",
                              link: "/about-us#partnerships",
                              section: "partnerships",
                            },
                            
                          ]}
                        />
                      </H2>
                    </>
                  ) : (
                    <>
                      <H2>
                        <DropDownMenu
                          title={"Webinar"}
                          options={[
                            {
                              name: "Upcoming Webinars",
                              children: [
                                {
                                  name: `${setting?.title || "Webinars"}`,
                                  link: `/upcoming_webinars/${setting?.slug}`,
                                },
                              ],
                            },

                            {
                              name: "ODR-Opportunities & Challenges",
                              link: "/resources/webinar-videos#webinar#one",
                            },
                            {
                              name: "ODR-Evaluation of Section 11 & Section 29A",
                              link: "/resources/webinar-videos#webinar#two",
                            },
                            {
                              name: "Past Webinars",
                              link: "/past-webinars",
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={"Services"}
                          options={[
                            {
                              name: "Arbitrations & Mediations",
                              link: "#our-offerings",
                              section: "our-offerings",
                            },
                            {
                              name: "ODR Platform Deployments",
                              link: "#odr",
                              section: "our-offerings",
                            },
                            {
                              name: "Live Transcription",
                              link: "#transcription",
                              section: "our-offerings",
                            },
                            {
                              name: "Case Management",
                              link: "#case-management",
                              section: "our-offerings",
                            },
                            
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.resources"]}
                          options={[
                            {
                              name: "Blogs",
                              link: "/resources/blogs",
                            },
                            {
                              name: "Model Clauses",
                              link: "/resources/model-clauses",
                            },
                            {
                              name: "Rules",
                              children: [
                                {
                                  name: "Negotiation",
                                  link: `/negotiation-rules`,
                                },

                                {
                                  name: "Mediation",
                                  link: `/mediation-rules`,
                                },
                                {
                                  name: "Arbitration",
                                  link: `/arbitration-rules`,
                                },
                              ],
                            },
                            {
                              name: "Awards",
                              link: "/resources/awards",
                            },
                          ]}
                        />
                      </H2>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.neutral"]}
                          options={[
                            {
                              name: "Arbitrators",
                              link: "/neutral/arbitrators",
                            },
                            {
                              name: "Mediators",
                              link: "/neutral/mediators",
                            },
                            {
                              name: "Login as Neutral",
                              link: process.env.REACT_APP_NEUTRAL_BASE_URL,
                            },
                          ]}
                        />
                      </H2>
                      <Link>
                        <H2>
                          <DropDownMenu
                            title={labels["appbar.training"]}
                            options={[
                              {
                                name: "Corporate Short Programme",
                                link: "/training/corporate-short-programme",
                              },
                              {
                                name: "Mediation Training Programme",
                                link: "/training/mediation-training-programme",
                              },
                              {
                                name: "World of Mediation",
                                link: "/training/world-of-mediation",
                              },
                            ]}
                          />
                        </H2>
                      </Link>
                      <H2>
                        <DropDownMenu
                          title={labels["appbar.about_us"]}
                          options={[
                            {
                              name: "About IAMC",
                              link: "/about-us",
                              section: "about-justact",
                            },
                            {
                              name: "Our Advantages",
                              link: "/about-us#our-advantages",
                              section: "our-advantages",
                            },
                            {
                              name: "How IAMC works",
                              link: "/about-us#how-it-works",
                              section: "how-it-works",
                            },
                            {
                              name: "Our Values",
                              link: "/about-us#our-values",
                              section: "our-values",
                            },
                            {
                              name: "Board of Directors",
                              link: "/about-us#board-of-directors",
                              section: "board-of-directors",
                            },
                            {
                              name: "Management Team",
                              link: "/about-us#management-team",
                              section: "management-team",
                            },
                            {
                              name: "Our Partners",
                              link: "/about-us#partnerships",
                              section: "partnerships",
                            },
                            
                          ]}
                        />
                      </H2>
                    </>
                  )} */}

                  <PrimaryCTAButton
                    style={{
                      marginRight: "1rem",
                      width: "auto",
                      padding: "12px 24px",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => {
                      navigate("#enquire-now");
                      setContactScrollTick((prev) => prev + 1);
                    }}
                  >
                    Get in Touch
                  </PrimaryCTAButton>
                  <PrimaryOutlinedCTAButton
                    style={{
                      marginRight: "1rem",
                      width: "auto",
                      padding: "10px 24px",
                      fontSize: "14px",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => navigate("/login")}
                  >
                    Login/Register
                  </PrimaryOutlinedCTAButton>
                </>
              ) : (
                <>
                  <div style={{ marginRight: "1rem" }}>
                    <Notification
                      count={notificationCount}
                      setCount={setNotificationCount}
                    />
                  </div>

                  {password === true ? (
                    <Row>
                      <CartIcon
                        src={require("../../../assets/images/cartIcon.svg")}
                      />
                      <ProfileName style={{ marginRight: 11 }}>
                        {"Payments"}
                      </ProfileName>
                      {cartCount ? <Count>{cartCount}</Count> : null}
                    </Row>
                  ) : (
                    <Row onClick={() => navigate("/dashboard/cart")}>
                      <CartIcon
                        src={require("../../../assets/images/cartIcon.svg")}
                      />
                      <ProfileName style={{ marginRight: 11 }}>
                        {"Payments"}
                      </ProfileName>
                      {cartCount ? <Count>{cartCount}</Count> : null}
                    </Row>
                  )}
                  {password === true ? (
                    <Row>
                      <HelpIcon
                        src={require("../../../assets/images/HelpHeader.svg")}
                      />
                      <ProfileName>{labels["appbar.help"]}</ProfileName>
                    </Row>
                  ) : (
                    <Row onClick={() => navigate("/dashboard/help")}>
                      <HelpIcon
                        src={require("../../../assets/images/HelpHeader.svg")}
                      />
                      <ProfileName>{labels["appbar.help"]}</ProfileName>
                    </Row>
                  )}
                  <Row onClick={handleLogout}>
                    <LogoutIcon
                      src={require("../../../assets/images/logout.svg")}
                    />
                    <LogoutText>{labels["appbar.logout"]}</LogoutText>
                  </Row>
                  {password === true ? (
                    <ProfileImage
                      src={
                        userObject.avatarUrl
                          ? userObject.avatarUrl
                          : require("../../../assets/images/userPlaceholder.svg")
                      }
                    />
                  ) : (
                    <ProfileImage
                      src={
                        userObject.avatarUrl
                          ? userObject.avatarUrl
                          : require("../../../assets/images/userPlaceholder.svg")
                      }
                      onClick={() => navigate("/dashboard/profile")}
                    />
                  )}
                  {password === true ? (
                    <ProfileName>{userObject.name}</ProfileName>
                  ) : (
                    <ProfileName onClick={() => navigate("/dashboard/profile")}>
                      {userObject.name}
                    </ProfileName>
                  )}
                </>
              )}
            </LinksContainer>
          )}
        </BigScreen>
        <SmallScreenMenu>
          {_.isEmpty(userObject) || !userObject?.emailVerified ? (
            <>
              <TemporaryDrawer title={setting?.title} slug={setting?.slug} />
            </>
          ) : (
            <SmallScreen>
              <Row>
                <div style={{ marginRight: 15 }}>
                  <Notification
                    count={notificationCount}
                    setCount={setNotificationCount}
                  />
                </div>

                {password === true ? (
                  <Row style={{ marginRight: 15 }}>
                    <CartIcon
                      src={require("../../../assets/images/cartIcon.svg")}
                    />
                    {cartCount ? <Count>{cartCount}</Count> : null}
                  </Row>
                ) : (
                  <Row
                    onClick={() => navigate("/dashboard/cart")}
                    style={{ marginRight: 15 }}
                  >
                    <CartIcon
                      src={require("../../../assets/images/cartIcon.svg")}
                    />
                    {cartCount ? <Count>{cartCount}</Count> : null}
                  </Row>
                )}

                <LogoutText onClick={handleLogout}>
                  {labels["appbar.logout"]}
                </LogoutText>
                {password === true ? (
                  <ProfileImage
                    src={
                      userObject.avatarUrl
                        ? userObject.avatarUrl
                        : require("../../../assets/images/userPlaceholder.svg")
                    }
                  />
                ) : (
                  <ProfileImage
                    src={
                      userObject.avatarUrl
                        ? userObject.avatarUrl
                        : require("../../../assets/images/userPlaceholder.svg")
                    }
                    onClick={() => navigate("/dashboard/profile")}
                  />
                )}
              </Row>
            </SmallScreen>
          )}
        </SmallScreenMenu>
        {!_.isEmpty(userObject) || userObject?.emailVerified ? (
          <MobileScreen>
            <Row>
              {password === true ? (
                <Row>
                  <CartIcon
                    src={require("../../../assets/images/cartIcon.svg")}
                  />
                  {cartCount ? <Count>{cartCount}</Count> : null}
                </Row>
              ) : (
                <Row onClick={() => navigate("/dashboard/cart")}>
                  <CartIcon
                    src={require("../../../assets/images/cartIcon.svg")}
                  />
                  {cartCount ? <Count>{cartCount}</Count> : null}
                </Row>
              )}

              <IconHolder
                style={{ marginLeft: 15, position: "relative" }}
                onClick={() => navigate("/dashboard/notification")}
              >
                <NotificationsIcon className="icon" />
                {notificationCount ? <span className="badge"></span> : null}
              </IconHolder>

              <Button
                onClick={() => {
                  setModal(!modal);
                }}
                size="small"
              >
                {modal ? <CloseIcon /> : <MenuIcon />}
              </Button>
            </Row>
            <Drawer
              anchor={"top"}
              open={modal}
              onClose={() => setModal(false)}
              style={{ zIndex: "1" }}
            >
              {password === true ? null : (
                <MenuModel
                  {...{
                    modal,
                    setModal,
                    NavPages,
                    hideLinks,
                    LandingPage,
                    cartCount,
                    userObject,
                    EXCLUDE_URL,
                    handleLogout,
                    stats,
                  }}
                />
              )}
            </Drawer>
          </MobileScreen>
        ) : null}
      </Toolbar>
    </AppBar>
  );
}
